import { __awaiter, __generator } from "tslib";
import { reportHomePageLoadedDuration, reportHomePagePaintDuration } from '../../logger/homePageLoad';
import '../polyfill';
import { fetchHandleError } from '../FetchConfig';
import { appDataInitialize, bootstrap } from './bootstrap';
fetchHandleError(function (error) {
    if (error.status === 401) {
        var path = '/web/errorInfo.html?errorMessage=授权失败，请重新登录';
        if (location.href.includes(':9999')) {
            path = '/errorInfo.html?errorMessage=授权失败，请重新登录';
        }
        location.replace(path);
    }
});
window.addEventListener('load', function () {
    reportHomePageLoadedDuration();
    reportHomePagePaintDuration();
});
appDataInitialize();
window.addEventListener('DOMContentLoaded', function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        bootstrap();
        return [2];
    });
}); });
